import Vue from 'vue'
import VueI18n from 'vue-i18n'
import store from '../store'
import { getDefaultLanguage, loadLanguageMessages } from './languages'

Vue.use(VueI18n)

// 根据语言进行选择
const defaultLanguage = getDefaultLanguage()

// 动态加载所有语言包（从统一配置自动生成）
const messages = loadLanguageMessages()

// 国际化
const i18n = new VueI18n({
  locale: localStorage.getItem('locale') || defaultLanguage,  // 优先使用存储的语言设置
  messages: messages,
  silentTranslationWarn: false,
  fallbackLocale: 'en', // 设置回退语言为英文
})

export default i18n
